import PropTypes from "prop-types"

export const MetricTypeOptionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  unit: PropTypes.string,
  selected: PropTypes.bool,
})

export const MetricItemShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  metricTypeOptions: PropTypes.arrayOf(MetricTypeOptionShape),
})

export const ColumnShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  contentSetId: PropTypes.string,
  proprietary: PropTypes.bool,
  items: PropTypes.arrayOf(MetricItemShape),
})

export const AvailableColumnShape = PropTypes.shape({
  category: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(ColumnShape).isRequired,
})

export const SubcategoryShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  selectedItemsCount: PropTypes.number,
  itemsCount: PropTypes.number,
  items: PropTypes.arrayOf(MetricItemShape),
})

export const CategoryShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  shouldShowCategory: PropTypes.bool.isRequired,
  subcategoriesFound: PropTypes.number.isRequired,
  subcategoriesAndItemsSelected: PropTypes.number.isRequired,
  totalSubcategoriesAndItems: PropTypes.number.isRequired,
  subcategories: PropTypes.arrayOf(SubcategoryShape),
})

export const AvailableMetricsShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  categories: PropTypes.arrayOf(CategoryShape).isRequired,
})
